import { useEffect } from "react";
import { GraduationCap, Users, MessageCircle } from "lucide-react";
import Doctors from "../components/Doctors";
import CtaBanner from "../components/CtaBanner";
import { Reveal, Eyebrow } from "../lib/data";

const TEAM_POINTS = [
  { icon: GraduationCap, title: "Formare continuă", desc: "Medicii noștri participă constant la cursuri și congrese, ca să-ți ofere cele mai moderne tratamente." },
  { icon: Users, title: "Abordare în echipă", desc: "Cazurile complexe sunt discutate împreună, astfel încât planul tău de tratament e gândit din toate punctele de vedere." },
  { icon: MessageCircle, title: "Comunicare simplă", desc: "Îți explicăm fiecare pas pe înțelesul tău, fără termeni complicați și fără grabă." },
];

const EchipaPage = () => {
  useEffect(() => {
    document.title = "Echipă | MEDAS Stomatologie Timișoara";
  }, []);

  return (
    <div className="pt-[76px] md:pt-[112px]">
      <Doctors />
      <section className="py-20 lg:py-24 bg-[#FBF7EF]" data-testid="team-approach">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="max-w-2xl">
            <Eyebrow>Cum lucrăm</Eyebrow>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
              O echipă care pune pacientul pe primul loc
            </h2>
            <p className="text-[#6B5C43] mt-4 text-base md:text-lg leading-relaxed">
              La MEDAS Dental Point nu ești doar un număr pe o foaie de consultație. Fiecare medic își
              ia timp să te asculte, să-ți explice opțiunile și să construiască împreună cu tine un plan
              de tratament realist, adaptat nevoilor și bugetului tău.
            </p>
          </Reveal>
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {TEAM_POINTS.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08}>
                <div
                  data-testid={`team-point-${i}`}
                  className="h-full bg-white rounded-2xl border border-[#EADFC6] p-6 hover:shadow-xl hover:shadow-[#A6823B]/10 hover:-translate-y-1 transition-all"
                >
                  <span className="w-12 h-12 rounded-xl bg-[#EFE7D6] flex items-center justify-center">
                    <p.icon className="w-6 h-6 text-[#A6823B]" />
                  </span>
                  <h3 className="font-display font-bold text-[#2A2521] mt-4">{p.title}</h3>
                  <p className="text-sm text-[#6B5C43] mt-2 leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CtaBanner />
    </div>
  );
};

export default EchipaPage;
